export const loginCopy = {
  title: "Вход в PinWiki",
  description: "Ответы строятся только по документам вашей организации.",
  submit: "Войти",
  pending: "Входим…",
  errorTitle: "Ошибка входа",
  brand: "Платформа знаний",
} as const;
